import React from 'react'
import buggerIcon from '../../assets/images/error.svg'
import styles from './error.module.less'


const ErrorHtml = () =>  (
  <div className={styles.errorMain}>
    <img src={buggerIcon} />
    <span className={styles.errorMainText}>ERROR</span>
    {/* <Button onClick={() => returnBack()}>GO HOME</Button> */}
  </div>
)

export default ErrorHtml
